// extracted by mini-css-extract-plugin
module.exports = {"carousel":"carousel_component_carousel__D2Ejy","carousel--extended-padding":"carousel_component_carousel--extended-padding__VuHTX"};